import { all, call, put, select, takeLatest, delay } from 'redux-saga/effects';
import { getUserSessionIdtoken } from '../helpers/userSession';
import { deleteRatings } from '../managers';
import { deleteManagedSoundcastRatings } from '../routines';
import { getUser } from '../selectors';

const deleteManagedSoundcastRatingsWorker = function* ({ payload: { soundcastId, ratings } }) {
  const payload = { soundcastId, ratings };
  try {
    yield put(deleteManagedSoundcastRatings.request(payload));

    const { id: userId } = yield select(getUser);
    const token = yield call(getUserSessionIdtoken);

    yield delay(2000);
    yield all(
      ratings.map(ratingId => {
        return call(deleteRatings, soundcastId, ratingId, {
          headers: { token, userId },
        });
      })
    );

    yield put(deleteManagedSoundcastRatings.success(payload));
  } catch (error) {
    yield put(deleteManagedSoundcastRatings.failure(payload, error));
  } finally {
    yield put(deleteManagedSoundcastRatings.fulfill(payload));
  }
};

const deleteManagedSoundcastRatingsWatcher = function* () {
  yield takeLatest(deleteManagedSoundcastRatings.TRIGGER, deleteManagedSoundcastRatingsWorker);
};

export default function* () {
  yield all([call(deleteManagedSoundcastRatingsWatcher)]);
}
